<template>
  <article class="soporte-layout">
    <nav class="breadcrumb has-succeeds-separator" aria-label="breadcrumbs">
      <ul>
        <li><a @click="$router.push({ name: 'support' })">Home</a></li>
        <li class="is-active">
          <a href="#" aria-current="page">{{ actualModule.name }}</a>
        </li>
      </ul>
    </nav>
    <template>
      <!-- {{actualModule}} -->
      <section class="soporte-layout__content">
        <!-- <h4>{{ section.name }}</h4> -->
        <ul>
          <li
            v-for="(article, $indexArticle) in actualModuleContent"
            :key="`section-${actualModule.name}-article-${$indexArticle}`"
          >
            <a
              class="color-primary"
              @click="toArticle(article, actualModule, 'out')"
              >{{ article.title }}</a
            >
          </li>
        </ul>
      </section>
    </template>
    <template v-if="list && list.length > 0">
      <section
        class="soporte-layout__content"
        v-for="(section, $index) in list"
        :key="`soporte-dash-${$index}`"
        :id="section.slug"
      >
        <h4>{{ section.name }}</h4>
        <ul>
          <li
            v-for="(article, $indexArticle) in section.content"
            :key="`section-${section.title}-article-${$indexArticle}`"
          >
            <a
              class="color-primary"
              @click="toArticle(article, section, 'in')"
              >{{ article.title }}</a
            >
          </li>
        </ul>
      </section>
    </template>
  </article>
</template>

<script>
export default {
  name: "SoporteLayout",
  props: ["list"],
  computed: {
    actualModule() {
      return this.$store.getters.actualModuleGetter;
    },
    actualModuleContent() {
      if (!this.actualModule.content) return [];
      return this.actualModule.content.filter(cont => Boolean(cont));
    }
  },
  mounted() {
    if (this.$route.hash) {
      console.log("window.offsetY ", window.pageYOffset);
      window.scrollTo(0, window.pageYOffset - 120);
    }
  },
  methods: {
    toArticle(art, sec, type) {
      let path = [
        {
          name: "home",
          path: "support"
        },
        {
          name: this.actualModule.name,
          path: "soporte-list",
          id: this.$route.params.id
        },
        {
          name: sec.name,
          path: "soporte-list",
          id: this.$route.params.id,
          hash: `#${sec.slug}`
        }
      ];
      if (this.list.length == 0 || !this.list || type === "out") {
        path.length = 2;
      }
      this.$router.push({
        name: "soporte-article",
        params: { slug: art.slug, path: path }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/general.scss";
@import "../../assets/styles/colors.scss";
.soporte-layout {
  padding: 0 0.5rem;
  &__content {
    font-weight: bold;
    text-align: start;
    margin-bottom: 3rem;
    h4 {
      font-weight: bold;
      font-size: 2rem;
      margin: 1em 0;
    }
    ul {
      list-style: none;
      // font-size: 1.5rem;
      li {
        border-bottom: thin solid $disabled;
        padding: 1rem 0;
        margin: 0;
        a {
          font-size: 1.2rem;
          cursor: pointer;
          &:hover {
            text-decoration: underline;
          }
        }
      }
    }
  }
}
.section-more-categories {
  background-color: #eafffe;
  padding: 5rem 1rem;
  padding-top: 2rem;
  margin: 0px;
  .more-categories-content {
    display: flex;
    flex-flow: column nowrap;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 0px;
  }
  h3 {
    text-align: start;
    font-weight: bold;
    font-size: 1rem;
    letter-spacing: 0.1em;
  }
  .categories {
    // display: flex;
    // flex-flow: row nowrap;
    // justify-content: space-between;
    // align-items: flex-start;
    width: 80%;
    margin: 3rem auto;
    .column {
      display: block;
      flex-basis: 0;
      flex-grow: 1;
      flex-shrink: 1;
      padding: 0;
    }
    ul {
      width: 100%;
      text-align: start;
      font-weight: bold;
      font-size: 0.9rem;
      list-style: none; /* Remove default bullets */
      margin-left: 1.5rem;
      margin-top: 1rem;
      li {
        margin: 0.8rem 0;
      }
    }

    ul li::before {
      content: "\2022"; /* Add content: \2022 is the CSS Code/unicode for a bullet */
      color: #058b87; /* Change the color */
      font-weight: bold; /* If you want it to be bold */
      display: inline-block; /* Needed to add space between the bullet and the text */
      width: 1em; /* Also needed for space (tweak if needed) */
      margin-left: -1em; /* Also needed for space (tweak if needed) */
    }
  }
  @include tablet() {
    h3 {
      font-size: 2rem;
    }
    .categories {
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      align-items: flex-start;
      ul {
        font-size: 1.2rem;
      }
    }
  }
  @include laptop() {
    padding: 2rem 3rem;
    margin-bottom: 3rem;
    h3 {
      margin: 1rem 0 2rem;
    }
    .categories {
      width: 100%;
      .column {
        padding: 0.75rem;
      }
      ul {
        list-style: disc;
        margin-left: 2rem;
        li {
          margin-bottom: 1rem;
        }
      }
    }
  }
}
// .breadcrumb {
//   margin: 0;
//   margin-bottom: 3rem;
//   text-align: start;
//   font-size: 1rem;
//   letter-spacing: 0.025em;
//   a {
//     cursor: pointer;
//   }
// }
.breadcrumb {
  ul {
    li:not(.is-active) {
      a {
        color: $primary;
      }
    }
  }
}
</style>
